<!-- TAB SELECTION -->
<cmps-tabset
    [hidden]="isCollapsed"
    [selectedTabRefId]="tab?.tabId"
    class="sc-header-tabs"
>
    <cmps-tabset-label-wrapper class="align-items-end">
        <ng-container *ngFor="let i of tabs">
            <ng-template
                cmpsTabLabel
                [tabRefId]="i?.tabId"
                let-ctx
            >
                <cmps-tab-button
                    theme="a"
                    [selected]="ctx.selected"
                    (click)="_onTabChange(i?.tabId)"
                    [cmpsTooltipTrigger]="_showTabTooltip() ? i.tabLabel : null"
                    [placement]="'bottom-center'"
                    trigger="hover"
                >
                    <span
                        cmpsTabButtonLabel
                        *ngIf="_user?.id === i.userId"
                    >
                        {{ _i18n._9295_MY_SCORECARDS | translate }}
                    </span>
                    <ng-container *ngIf="_user?.id !== i.userId">
                        <span cmpsTabButtonLabel>{{ i.tabLabel }}</span>
                        <button
                            class="ml-3 cmps-icon-button--sm cmps-icon-button--no-bg"
                            cmpsIconButton
                            (click)="_onTabClose(i.tabId, $event)"
                        >
                            <cmps-icon svgIcon="close"></cmps-icon>
                        </button>
                    </ng-container>
                </cmps-tab-button>
            </ng-template>
        </ng-container>
        <ng-template
            cmpsTabLabel
            tabRefId="add"
        >
            <div
                [cmpsTooltipTrigger]="
                    _cantAddMoreTabs() && _i18n._9891_NO_MORE_TABS_CAN_BE_ADDED
                        | translate
                "
                [placement]="'left-center'"
            >
                <button
                    class="cmps-button--sm cmps-button--no-bg"
                    cmpsButton
                    (click)="_onAddUser($event)"
                    [disabled]="_cantAddMoreTabs()"
                >
                    <cmps-icon svgIcon="plus-circle"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9296_ADD_SCORECARDS | translate
                    }}</span>
                </button>
            </div>
        </ng-template>
    </cmps-tabset-label-wrapper>
    <div
        [cmpsTooltipTrigger]="_i18n._9890_RETURN_TO_PULSE | translate"
        trigger="hover"
        placement="left-center"
    >
        <button
            class="cmps-icon-button--no-bg h-100"
            cmpsIconButton
            (click)="_onCloseAllTabs($event)"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
</cmps-tabset>
<!-- END TAB SELECTION -->

<!-- DETAIL INFORMATION -->
<ng-container
    *ngIf="tab?.hasData"
    [ngTemplateOutlet]="scorecardInfoTpl"
></ng-container>
<!-- END DETAIL INFORMATION -->

<!-- DETAIL INFORMATION MIN  -->
<ng-container
    *ngIf="tab?.hasData"
    [ngTemplateOutlet]="scorecardInfoMinTpl"
></ng-container>
<!-- END DETAIL INFORMATION MIN  -->

<ng-container
    *ngIf="!tab?.pending && !tab?.hasData"
    [ngTemplateOutlet]="noDataToShow"
></ng-container>

<!-- TEMPLATES -->
<!-- Scorecar Info Template -->
<ng-template #scorecardInfoTpl>
    <div
        class="row mr-0 ml-0 mt-3"
        [hidden]="isCollapsed"
    >
        <div class="col-4">
            <h6
                class="sc-pf-title"
                *ngIf="tab?.isManager"
            >
                {{ _i18n._9354_MANAGER_SCORECARD | translate }}
            </h6>
            <h6
                class="sc-pf-title"
                *ngIf="!tab?.isManager"
            >
                {{ _i18n._9355_PERFORMANCE_SCORECARD | translate }}
            </h6>
            <p class="sc-pf-text m-0">
                <span>{{ _i18n._48_MANAGER | translate }}: </span>
                <span class="sc-pf-manager-name">{{ tab?.managerName }}</span>
            </p>
            <p class="sc-pf-text m-0">
                <span>{{ _i18n._64_SITE | translate }}:</span>
                {{ tab?.siteName }}
            </p>
            <p class="sc-pf-text">
                <span
                    >{{ _i18n._9357_MY_NUMBER_OF_ACTIVE_DAYS | translate }}:
                </span>
                {{ tab?.numberOfDays }}
            </p>
        </div>
        <div class="col-5">
            <p class="sc-pf-text m-0 mb-2 mt-2">
                {{ _i18n._9358_CURRENT_SCORECARD_PERIOD | translate }}
            </p>
            <div class="row">
                <div class="col sc-pf-text">
                    <span>{{
                        tab?.periodStartDate | cmpsDate: 'MM-dd-y'
                    }}</span>
                    <span class="sc-pf-text-content">{{
                        _i18n._9253_TO | translate
                    }}</span>
                    <span>{{ tab?.periodEndDate | cmpsDate: 'MM-dd-y' }}</span>
                </div>
            </div>
            <button
                class="sc-pf-text sc-pf-export p-0 cmps-button--no-bg"
                cmpsButton
                (click)="_onExportClick($event)"
            >
                <cmps-icon svgIcon="file"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9359_EXPORT_AS_PDF | translate
                }}</span>
            </button>
        </div>
        <div class="col">
            <div
                class="col-4 float-right no-padding"
                *ngIf="_canUseLiveData"
                style="margin: 10px 35px 0 0"
            >
                <cmps-sc-toggle-switch
                    [isSelected]="useLiveData"
                    [text]="_i18n._9367_USE_LIVE_DATA | translate"
                    [canBeToggled]="!tab?.pending"
                    (toggleSelection)="_onToggleUseLiveData($event)"
                >
                </cmps-sc-toggle-switch>
            </div>
        </div>
    </div>
</ng-template>
<!-- Scorecar Info Template Min -->
<ng-template #scorecardInfoMinTpl>
    <div
        class="row sc-pf-min-info ml-0 mr-0 align-items-center h-100"
        [hidden]="!isCollapsed"
    >
        <div class="col-3">
            <h6
                class="sc-pf-title"
                *ngIf="tab?.isManager"
            >
                {{ _i18n._9354_MANAGER_SCORECARD | translate }}
            </h6>
            <h6
                class="sc-pf-title"
                *ngIf="!tab?.isManager"
            >
                {{ _i18n._9355_PERFORMANCE_SCORECARD | translate }}
            </h6>
        </div>
        <div class="col-6">
            <div class="row align-items-center">
                <div class="col">
                    <div class="row">
                        <span class="col-12 col-lg-5 sc-pf-text">{{
                            _i18n._9358_CURRENT_SCORECARD_PERIOD | translate
                        }}</span>
                        <span class="col-12 col-lg-6 sc-pf-text">
                            <span>{{
                                tab?.periodStartDate | cmpsDate: 'MM-dd-y'
                            }}</span>
                            <span class="sc-pf-text-content">{{
                                _i18n._9253_TO | translate
                            }}</span>
                            <span>{{
                                tab?.periodEndDate | cmpsDate: 'MM-dd-y'
                            }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <button
                class="sc-pf-text sc-pf-export p-0 cmps-button--no-bg"
                cmpsButton
                (click)="_onExportClick($event)"
            >
                <cmps-icon svgIcon="file"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9359_EXPORT_AS_PDF | translate
                }}</span>
            </button>
        </div>
        <div
            class="col-1 no-padding"
            *ngIf="_canUseLiveData"
        >
            <cmps-sc-toggle-switch
                [isSelected]="useLiveData"
                [text]="_i18n._9367_USE_LIVE_DATA | translate"
                [canBeToggled]="!tab?.pending"
                (toggleSelection)="_onToggleUseLiveData($event)"
            >
            </cmps-sc-toggle-switch>
        </div>
    </div>
</ng-template>
<!-- No Data Info -->
<ng-template #noDataToShow>
    <div class="my-3 text-center">
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
        <div
            class="col-1 float-right no-padding"
            *ngIf="_canUseLiveData"
            style="margin: -16px 50px 0 0"
        >
            <cmps-sc-toggle-switch
                [isSelected]="useLiveData"
                [text]="_i18n._9367_USE_LIVE_DATA | translate"
                [canBeToggled]="!tab?.pending"
                (toggleSelection)="_onToggleUseLiveData($event)"
            >
            </cmps-sc-toggle-switch>
        </div>
    </div>
</ng-template>
<!-- END TEMPLATES -->
